import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, Loader, CreditCard, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BetalingCreditsPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const orderId = searchParams.get("orderId");

  const [status, setStatus] = useState("laden");
  const [orderInfo, setOrderInfo] = useState(null);
  const [polls, setPolls] = useState(0);

  useEffect(() => {
    if (!orderId || !user?.token) return;

    const check = async () => {
      try {
        const r = await fetch(`${API}/api/schedule/credits/betaling-status/${orderId}`, {
          headers: { Authorization: `Bearer ${user.token}` }
        });
        if (!r.ok) { setStatus("fout"); return; }
        const d = await r.json();
        setOrderInfo(d);
        if (d.betaald) {
          setStatus("betaald");
        } else if (["mislukt", "geannuleerd", "verlopen", "fout"].includes(d.status)) {
          setStatus("mislukt");
        } else {
          setStatus("wachten");
        }
      } catch {
        setStatus("fout");
      }
    };

    check();
  }, [orderId, user?.token, polls]);

  useEffect(() => {
    if (status !== "wachten") return;
    const t = setTimeout(() => setPolls(p => p + 1), 3000);
    return () => clearTimeout(t);
  }, [status, polls]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="max-w-sm w-full bg-[#0f0f0f] border border-white/8 rounded-2xl p-8 text-center">

        {status === "laden" || status === "wachten" ? (
          <>
            <div className="w-16 h-16 rounded-2xl bg-[#C9A84C]/10 flex items-center justify-center mx-auto mb-5">
              <Loader size={28} className="text-[#C9A84C] animate-spin" />
            </div>
            <h1 className="text-white font-black text-xl mb-2">Betaling verwerken</h1>
            <p className="text-zinc-500 text-sm">We controleren de betaalstatus...</p>
            {orderId && <p className="text-zinc-700 text-xs mt-3 font-mono">{orderId}</p>}
          </>
        ) : status === "betaald" ? (
          <>
            <div className="w-16 h-16 rounded-2xl bg-green-500/10 flex items-center justify-center mx-auto mb-5">
              <CheckCircle size={32} className="text-green-400" />
            </div>
            <h1 className="text-white font-black text-xl mb-2">Betaling geslaagd!</h1>
            {orderInfo && (
              <p className="text-zinc-400 text-sm mb-1">
                <span className="text-[#C9A84C] font-black text-2xl">{orderInfo.credits}</span>
                {" "}credits toegevoegd aan je account
              </p>
            )}
            {orderInfo?.pakket_naam && (
              <p className="text-zinc-600 text-xs mb-5">{orderInfo.pakket_naam}</p>
            )}
            <button
              onClick={() => navigate("/account")}
              className="w-full flex items-center justify-center gap-2 py-3 rounded-xl text-black font-bold text-sm mt-4"
              style={{ background: "#C9A84C" }}>
              Naar mijn account <ArrowRight size={15} />
            </button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-2xl bg-red-500/10 flex items-center justify-center mx-auto mb-5">
              <XCircle size={32} className="text-red-400" />
            </div>
            <h1 className="text-white font-black text-xl mb-2">Betaling mislukt</h1>
            <p className="text-zinc-500 text-sm mb-5">Er is iets misgegaan met de betaling. Probeer het opnieuw.</p>
            <button
              onClick={() => navigate("/account")}
              className="w-full py-3 rounded-xl border border-white/10 text-zinc-400 font-semibold text-sm hover:text-white transition-colors">
              Terug naar account
            </button>
          </>
        )}
      </div>
    </div>
  );
}
